<template>
  <div :class="['frame-poster-gallery', { 'frame-poster-gallery--with-slider': frameWithSlider }]">
    <div class="frame-poster-gallery__two-items" v-if="frameWithoutSlider">
      <sui-grid :columns="slides.length || 1" centered class="frame-grid-collection__three-columns">
        <sui-grid-row>
          <sui-grid-column
            v-for="(slide, index) in slides"
            :computer="slides.length <= 2 ? 6 : null"
            :mobile="mobileColumns"
            :key="`${slide.url}-${index}`"
          >
            <img :src="slide.url" />
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>
    </div>
    <arrow-slider
      class="frame-poster-gallery__arrow-slider"
      @click="nextSlide"
      v-if="frameWithSlider"
    />
    <slick
      ref="slick"
      :options="slickOptions"
      class="frame-poster-gallery__slider"
      v-if="frameWithSlider"
    >
      <article v-for="(slide, index) in slides" :key="`${slide.url}-${index}`">
        <div
          class="frame-poster-gallery__slider__item"
          :style="{ background: `url(${slide.url}) no-repeat center center` }"
        ></div>
      </article>
    </slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import ArrowSlider from "@/assets/arrow-slider.svg";

export default {
  name: "frame-poster-gallery",

  components: {
    Slick,
    "arrow-slider": ArrowSlider,
  },

  props: {
    isSlider: {
      type: Boolean,
      default: false,
    },
    slides: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      mobileColumns: null,
      slickOptions: {
        slidesToShow: 2,
        variableWidth: true,
        arrows: false,
        infinite: true,
        speed: 900,
        cssEase: "cubic-bezier(.15,.22,.6,.9)",
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ],
      },
    };
  },

  computed: {
    frameWithoutSlider() {
      const clearArr = this.slides.filter((item) => item !== undefined);
      return (clearArr.length <= 3 && !this.isSlider) || clearArr.length <= 2;
    },

    frameWithSlider() {
      const clearArr = this.slides.filter((item) => item !== undefined);
      return (clearArr.length >= 3 && this.isSlider) || clearArr.length > 3;
    },
  },

  mounted() {
    this.setColumns();

    $(window).on("resize", () => {
      this.setColumns();
    });
  },

  methods: {
    nextSlide() {
      this.$refs.slick.next();
    },

    setColumns() {
      if ($(window).width() < 1000) {
        this.mobileColumns = 16;
      } else {
        this.mobileColumns = null;
      }
    },
  },
};
</script>

<style lang="scss">
.frame-poster-gallery {
  height: auto;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 0 30px;

  &--with-slider {
    width: 90%;
    left: 10%;
    padding: 0;
  }

  &__slider {
    display: flex;
    position: relative;

    &__item {
      height: 55vw;
      background-size: cover !important;
    }
  }

  .slick-track {
    display: flex;
    overflow: hidden;
    width: 100%;
  }

  .slick-slider {
    display: flex;
    overflow: hidden;
    width: 100%;
    justify-content: flex-end;
  }

  .slick-list {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-perspective: 1000px;
    perspective: 1000px;
  }

  .slick-slide {
    margin-left: 15px;
    width: 40vw !important;
    overflow: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    transition: opacity 0.3s ease-out;
  }

  &__arrow-slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -130px;
    margin: auto;
    width: 80px;
    height: 80px;
    cursor: pointer;
    transition: all 0.3s ease-out;
    opacity: 1;

    image {
      width: 80px;
      height: 80px;
    }

    &:hover {
      opacity: 0.5;
      transition: opacity 0.3s ease-in-out;
    }
  }

  &__two-items {
    height: auto;
    width: 100%;

    img {
      width: 40vw;
    }

    .column {
      padding: 8px !important;
    }
  }
}

@media (max-width: 1500px) {
  .frame-poster-gallery {
    &__arrow-slider {
      left: -9%;
    }

    &__two-items {
      img {
        width: 100%;
      }
    }
  }
}

@media (max-width: 1300px) {
  .frame-poster-gallery {
    &__arrow-slider {
      left: -80px;
      width: 60px;
      height: 60px;

      image {
        width: 60px;
        height: 60px;
      }
    }

    &__two-items {
      img {
        width: 100%;
      }
    }
  }
}

@media (max-width: 1000px) {
  .frame-poster-gallery {
    padding: 20px;

    &__two-items {
      .row {
        padding: 0 !important;

        .column {
          padding: 0 !important;
          margin-bottom: 20px !important;
          width: 100% !important;
        }
      }
    }

    .slick-slide {
      width: 60vw !important;
    }

    &__slider {
      &__item {
        height: 85vw;
      }
    }

    &__arrow-slider {
      width: 40px;
      height: 40px;
      left: -30px;

      image {
        width: 40px;
        height: 40px;
      }
    }
  }
}

@media (max-width: 400px) {
  .frame-poster-gallery {
    padding: 20px;

    &__arrow-slider {
      width: 30px;
      height: 30px;
      left: -25px;

      image {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
